import React from "react";
import { useTranslation } from 'react-i18next';


const StorySection = () => {
  const { t } = useTranslation();

  return (
    <div className="fz-about-area">
      <div className="container">
        <div className="row gy-5">
          <div className="col-xl-6">
            <div className="fz-about-images">
              <div className="row g-0">
                <div className="col-sm-8 col-6">
                  <div className="fz-about-images-left">
                    <div className="fz-about-images-left-img">
                      <img src="assets/images/about-img-2.jpg" alt="about1-1.png" />
                    </div>

                    <div className="fz-about__infos mt-30">
                      <div className="fz-about__members">
                        <span className="fz-about__members-amount">{t("30K+")}</span>
                        <span className="fz-about__members-label">
                          {t("Active Customer")} 
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-sm-4 col-6 align-self-end align-self-xxs-start">
                  <div className="fz-about-images-right">
                    <div className="fz-about-images-right-img">
                      <img src="assets/images/about-img-1.jpg" alt="about2-1.png" />
                    </div>

                    <div className="fz-about-images-right__card">
                      <div className="fz-about-images-right__card-wrapp">
                        <div className="fz-about-images-right__card-inner">
                          <span className="fz-about-images-right__card-text">
                            {t("Since From")} 
                          </span>
                          <span className="fz-about-images-right__card-year">
                            {t("2020")} 
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-6">
            <div className="fz-about-right-content">
              <h4 className="fz-about-right-title">{t("About Our Story")}</h4>
              <p className="fz-about-right-descr">
                {t("About_decription")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StorySection;
